export const generateRandomId = () => {
  if (self && self.crypto && typeof self.crypto.randomUUID === 'function') {
    return self.crypto.randomUUID();
  }

  return Math.random().toString() + Math.random().toString() + Math.random().toString();
};
